import { h } from "preact"

export default function ErrorSolid(props: any) {
  return h(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      ...props,
    },
    h("path", {
      d:
        "M16 2a14 14 0 1 0 0 28 14 14 0 0 0 0-28zm0 22a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1.5-6.5a1.5 1.5 0 1 1-3 0v-8a1.5 1.5 0 1 1 3 0v8z",
    }),
  )
}
